import { Component, Input, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { NavController } from '@ionic/angular';
import { EventItem } from 'src/app/models/event-item';
import { placeholder } from 'src/app/models/placeholder';

@Component({
  selector: 'single-banner',
  templateUrl: './single-banner.component.html',
  styleUrls: ['./single-banner.component.scss'],
})
export class SingleBannerComponent implements OnInit {
  @Input() itemData: EventItem;
  @Input() showCTA: boolean;
  public imagePlaceholder = placeholder;
  constructor(private navControl: NavController) {}

  ngOnInit() {}

  async routeTo(itemData) {
    const link = itemData.redirectURL || itemData.landing_url || itemData.link;
    if (link) {
      if (itemData.banner_type && itemData.banner_type === 'internal_url') {
        this.navControl.navigateForward([decodeURIComponent(link)]);
      } else {
        await Browser.open({ url: link });
      }
    }
  }
}
